var rich_content_viewer_default = {
  "fontElementMap": "qM9t3",
  "wrapper": "_6CaN1",
  "pluginContainerMobile": "-tG-b",
  "viewer": "b1aLp",
  "android": "Dyh35",
  "rootedTraversedContent": "p8yaQ",
  "atomic": "rxOG6",
  "toolbar": "sEqlk",
  "block": "_21Cyo"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
